import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u771446010/domains/dev.jbcodeapp.in/hbuilds/source/repository/components/Partials/DynamicPortfolio.tsx");
